export const workContent = [
  //project start
  {
    shortTitle: "test",
    title: "9ms - Pleats | München",
    slug: "9ms-pleats-muenchen",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/9ms-pleats-muenchen/lichtgestalten-9ms-pleats-projektion-muenchen-1.jpg",
    imageTitle: "9ms - Pleats | Einstein Kultur, München",
    galleryContent:[
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/9ms-pleats-muenchen/lichtgestalten-9ms-pleats-projektion-muenchen-1.jpg",
        altEn: "Projection mapping at Einstein Kutlur, Munich",
        altDe: "Video-Mapping im Einstein Kultur, München",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/9ms-pleats-muenchen/lichtgestalten-9ms-pleats-projektion-muenchen-6.jpg",
        altEn: "Audio-reactive video art in Munich",
        altDe: "Audioreaktive Videokunst in München",
      },
      {
        type: "loop",
        url: "https://lichtgst.uber.space/videoLoops/projects/9ms-pleats-muenchen/lichtgestalten-9ms-pleats-muenchen-raul-snippet.mp4",
        aspect: "1.77777778",
        altEn: "9ms - Pleats live video at Einstein Kultur, Munich",
        altDe: "9ms - Pleats Live Video im Einstein Kultur, München",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/9ms-pleats-muenchen/lichtgestalten-9ms-pleats-projektion-muenchen-4.jpg",
        altEn: "Random walk shader video mapping at Einstein Kultur, Munich",
        altDe: "Random Walk Shader Video Mapping im Einstein Kultur, München",
      },
      {
        type: "loop",
        url: "https://lichtgst.uber.space/videoLoops/projects/9ms-pleats-muenchen/lichtgestalten-9ms-pleats-muenchen-snippet.mp4",
        aspect: "1.77777778",
        altEn: "9ms Live Snippet",
        altDe: "9ms Live Ausschnit",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/9ms-pleats-muenchen/lichtgestalten-9ms-pleats-projektion-muenchen-7.jpg",
        altEn: "Live video projection in Munich",
        altDe: "Live Video-Projektion in München",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/9ms-pleats-muenchen/lichtgestalten-9ms-pleats-projektion-muenchen-8.jpg",
        altEn: "audio-reactive GLSL-Shader for 9ms",
        altDe: "audio-reaktiver GLSL-Shader für 9ms",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/9ms-pleats-muenchen/lichtgestalten-9ms-pleats-projektion-muenchen-9.jpg",
        altEn: "Light art in Munich",
        altDe: "Lichtkunst in München",
      },
    ],
    descriptionEn:
      'The two drummers Florian König and Simon Popp released their debut-album "9ms - Pleats" on February 26th 2021 via Squama Recordings. For the tracks "Raul", "Kii" and "Tome" we collaborated with director Johannes Brugger to record one-take videos with audio-reactive visuals. The intense and feedback-laden "Raul" was set to distorted squares opening an infinite room vanishing in the dark, while the camera orbits the two drummers at fast pace. The sounds of "Kii" and "Tome" gave some input to the randomly walking lines for an audio-reactive visual which was derived from the original cover artwork of "Pleats" designed by Maximilian Schachtner (dailydialogue.cc).',
    descriptionDe:
      'Am 26. Februar 2021 veröffentlichten die beiden Münchner Schlagzeuger Florian König und Simon Popp ihr Debüt-Album "9ms - Pleats" via Squama Recordings. Zusammen mit dem Regisseur und Kamermann Johannes Brugger arbeiteten wir an Videos zu den Songs "Raul", "Kii" und "Tome". Eine kreiselnde Kamerabewegung und auf das Gewölbe gemappte Projektionen von scheinbar in der Unendlichkeit verschwindenden, verzerrten Quadraten begleiten "Raul", das mit intensiven Rhythmen und vielschichtigen Feedbackschwaden daherkommt. Die Sounds von "Kii" und "Tome" gebe Impulse an die sonst zufälligen Bewegung von wandernden Partikeln, deren Gestaltung dem von Maximilian Schachtner (dailydialogue.cc) gestalteten Cover-Artwork des Albums "Pleats" abgeleitet wurde.',
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["23. - 24.01.2021"],
      },
      {
        slugCreditsEn: "Music",
        slugCreditsDe: "Musik",
        values: [
          "9ms | Florian König, Simon Popp #https://9msmusic.bandcamp.com/album/pleats",
        ],
      },
      {
        slugCreditsEn: "Label",
        slugCreditsDe: "Label",
        values: [
          "Squama Recordings #https://squamarecordings.bandcamp.com/",
        ],
      },
      {
        slugCreditsEn: "Album Artwork",
        slugCreditsDe: "Grafikgestaltung Album",
        values: [
          "Maximilian Schachtner #https://dailydialogue.cc/",
        ],
      },
      {
        slugCreditsEn: "Director, DoP",
        slugCreditsDe: "Regie, Kamera",
        values: [
          "Johannes Brugger #https://vimeo.com/johannesbrugger",
        ],
      },
      {
        slugCreditsEn: "Gimbal Operator",
        slugCreditsDe: "Gimbal Operator",
        values: [
          "Clemens Krüger #https://www.clemenskrueger.com/ABOUT-ME",
        ],
      },
      {
        slugCreditsEn: "1. AC",
        slugCreditsDe: "Kameraassistent",
        values: [
          "Felix Riedelsheimer #http://felix-riedelsheimer.de/",
        ],
      },
      {
        slugCreditsEn: "Animation, Projection Mapping",
        slugCreditsDe: "Animation, Projektion",
        values: [
          "Lichtgestalten",],
      },
    ],
    tags: ["artDirection", "animation", "mapping"],
  },
  //project start
  {
    shortTitle: "test",
    title: "Occhio Lightstream | Passau",
    slug: "occhio-lightstream-passau",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/occhio-lightstream-passau/lichtgestalten-occhio-lightstream-passau-projection-8.png",
    imageTitle: "Occhio Lightstream | Fels der Brandung, Passau",
    galleryContent:[
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/occhio-lightstream-passau/lichtgestalten-occhio-lightstream-passau-projection-8.png",
        altEn: "Video-mapping for Occhio with particle animation",
        altDe: "Occhio Lampe mit projizierten Partikeln",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/occhio-lightstream-passau/lichtgestalten-occhio-lightstream-passau-projection-5.png",
        altEn: "Occhio Mito raggio in front of projection mapping",
        altDe: "Occhio Mito raggio vor Videoprojektion",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/occhio-lightstream-passau/lichtgestalten-occhio-lightstream-passau-projection-7.png",
        altEn: "Occhio Mito raggio in front of video art",
        altDe: "Occhio Mito raggio vor Videokunst",
      },
      {
        type: "loop",
        url: "https://lichtgst.uber.space/videoLoops/projects/occhio-lightstream-passau/occhio-lightstream-clouds-trailer-sm.mp4",
        aspect: "1.77777778",
        altEn: "GLSL shader for Occhio, Munich",
        altDe: "GLSL-Videoprojektion für Occhio, München",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/occhio-lightstream-passau/lichtgestalten-occhio-lightstream-passau-projection-6.png",
        altEn: "Occhio Mito raggio and GLSL shader projection mapping",
        altDe: "Occhio Mito raggio mit GLSL-Shader-Projektion",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/occhio-lightstream-passau/lichtgestalten-occhio-lightstream-passau-projection-9.png",
        altEn: "Projection mapping at Fels der Brandung, Passau, with Occhio Mito raggio",
        altDe: "Videoprojektion im Fels der Brandung, Passau, mit Occhio Mito raggio",
      },
      {
        type: "loop",
        url: "https://lichtgst.uber.space/videoLoops/projects/occhio-lightstream-passau/occhio-lightstream-sphere-particles-trailer-sm.mp4",
        aspect: "1.77777778",
        altEn: "GLSL particle system for Occhio, Munich",
        altDe: "GLSL-Partikelanimation für Occhio, München",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/occhio-lightstream-passau/lichtgestalten-occhio-lightstream-passau-projection-10.png",
        altEn: "Particle projection mapping and Occhio Mito raggio",
        altDe: "Partikelprojektion mit Occhio Mito raggio",
      },
    ],
    descriptionEn:
      'For Occhio, a Munich-based lighting design company, lichtgestalten created several realtime animations. Mimicking organic structures and movements, these GLSL shader driven animations were programmed in TouchDesigner and projected onto the walls of the "Fels in der Brandung" building located in Passau. The final result was a sureal short film playing with the contrast of the blue hour and the warm light of the Occhio luminaires.',
    descriptionDe:
      'Für den Designleuchten-Hersteller Occhio aus München kreierten lichtgestalten verschiedene generative Animation. Als Kulisse diente der "Fels in der Brandung" in Passau, auf dessen Wände mit in TouchDesigner programmierten GLSL-Shadern projiziert wurde. Diese in Echtzeit generierten Animationen waren an organische Strukturen und Bewegungen angelehnt und erzeugten ein Spiel mit dem Kontrast zwischen den Farben der "Blauen Stunde" und dem warmen Licht der Occhio-Leuchten.',
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["24.09.2020"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: [
          "Occhio #https://de.occhio.de/",
        ],
      },
      {
        slugCreditsEn: "Lead",
        slugCreditsDe: "Lead",
        values: [
          "Avantgarde #https://avantgarde.net",
        ],
      },
      {
        slugCreditsEn: "Art Direction, Lighting",
        slugCreditsDe: "Art Direction, Licht",
        values: [
          "Matthias Singer #http://507nm.de",
          "Clemens Von Loeffelholz #https://clemensloeffelholz.com/",
        ],
      },
      {
        slugCreditsEn: "Animation, Projection Mapping",
        slugCreditsDe: "Animation, Projektion",
        values: [
          "Lichtgestalten",],
      },
    ],
    tags: ["animation", "mapping"],
  },
  //project start
  {
    shortTitle: "test",
    title: "Waterfall | Ritter Sport",
    slug: "waterfall-ritter-sport",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/waterfall-ritter-sport/lichtgestalten-ritter-sport-kakao-klasse_1.jpg",
    imageTitle: "Waterfall Ritter Sport",
    galleryContent:[
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/waterfall-ritter-sport/lichtgestalten-ritter-sport-kakao-klasse_1.jpg",
        altEn: "Waterfall projection mapping at Ritter Sport Store, Berlin",
        altDe: "Wasserfall-Videoprojektion in der Ritter Sport Schokowelt, Berlin",
      },
      {
        type: "loop",
        url: "https://lichtgst.uber.space/videoLoops/projects/waterfall-ritter-sport/lichtgestalten-waterfall-ritter-sport-loop.mp4",
        altEn: "Waterfall projection mapping for Ritter Sport Kakaoklasse",
        altDe: "Wasserfall-Videoprojektion für die Ritter Sport Kakaoklasse",
      },
      {
        type: "video",
        url: "https://vimeo.com/327661457#t=4s",
        aspect: "1.77777778",
        altEn: "Video of waterfall projection mapping at Ritter Sport Store, Berlin",
        altDe: "Video der Wasserfall-Projektion in der Ritter Sport Schokowelt, Berlin",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/waterfall-ritter-sport/lichtgestalten-ritter-sport-kakao-klasse_2.jpg",
        altEn: "Ritter Sport Kakaoklasse release event with waterfall projection mapping",
        altDe: "Ritter Sport Kakaoklasse mit Wasserfall-Videoprojektion",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/waterfall-ritter-sport/lichtgestalten-ritter-sport-kakao-klasse_3.jpg",
        altEn: "Video art at Ritter Sport Store, Berlin",
        altDe: "Medienkunst in der Ritter Sport Schokowelt, Berlin",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/waterfall-ritter-sport/lichtgestalten-ritter-sport-kakao-klasse_4.jpg",
        altEn: "Waterfall projection mapping in Berlin for Ritter Sport",
        altDe: "Wasserfall-Videoprojektion in Berlin für Ritter Sport",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/waterfall-ritter-sport/lichtgestalten-ritter-sport-kakao-klasse_5.jpg",
        altEn: "Ritter Sport flagshipstore with waterfall video mapping",
        altDe: "Ritter Sport Schokowelt mit Wasserfall-Projektion",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/waterfall-ritter-sport/lichtgestalten-ritter-sport-kakao-klasse_6.jpg",
        altEn: "Projection mapping for Ritter Sport Kakaoklasse",
        altDe: "Videoprojektion für die Ritter Sport Kakaoklasse",
      },
    ],
    descriptionEn:
      "lichtgestalten were invitied by Brad Rabbit to realize a waterfall projection mapping for the release of Ritter Sport’s new „Kakao-Klasse“ chocolates. Spanning two floors in the Ritter Sport flagshipstore, we used several projectors to create a seamless waterfall. The waterfall interacted with the square elements mounted to the wall, featuring the artworks of the new chocolate classes. The two escelators right in front of the „screen“ and few possibilities to place the projectors made this mapping quite a challenge, which was overcome by planning, modelling and previsualising everything in 3D beforehand.",
    descriptionDe:
      "Für die Veröffentlichung der 'Kakao-Klasse' von Ritter Sport wurden wir von Brad Rabbit beauftragt, den Lichthof der Ritter Sport Schokowelt in Berlin mit einem projizierten Wasserfall in einen Dschungel zu verwandeln. Die Projektion erstreckte sich über zwei Stockwerke und integrierte vorhandene architektonische Elemente als Kollisionsobjekte der projizierten Flüssigkeitssimulation. Um die komplexen räumlichen Gegebenheiten bei der Umsetzung zu berücksichtigen, bauten wir das Gebäude virtuell nach und konnten so eine problemlose Umsetzung ohne Überraschungen planen.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["02.02.2019"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: [
          "Brad Rabbit",
          "Bareis-Nicolaus #https://www.bareis-nicolaus.com",
        ],
      },
      {
        slugCreditsEn: "Technical Planning, Hardware, Projection Mapping",
        slugCreditsDe: "Technische Planung, Installation, Mapping",
        values: [
          "Lichtgestalten",
        ],
      },
      {
        slugCreditsEn: "Animation",
        slugCreditsDe: "Animation",
        values: [
          "Gero Eckhardt",
        ],
      },
    ],
    tags: ["artDirection", "mapping", "installation"],
  },
  //project start
  {
    shortTitle: "test",
    title: "Mercedes Benz | CASE",
    slug: "mercedes-benz-case",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/mercedes-benz-case/mercedes-benz-case-lichtgestalten-3.jpg",
    imageTitle: "Mercedes Benz CASE",
    galleryContent:[
      {
        type: "video",
        url: "https://vimeo.com/309614930",
        aspect: "2.253703",
        altEn: "Mercedes Benz CASE projection mapping",
        altDe: "Mercedes Benz CASE Projektion und Mapping",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/mercedes-benz-case/mercedes-benz-case-lichtgestalten-3.jpg",
        altEn: "Mercedes Benz CASE rear projection mapping",
        altDe: "Rückprojektion für Mercedes Benz CASE",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/mercedes-benz-case/mercedes-benz-case-lichtgestalten-1.jpg",
        altEn: "Mercedes Benz CASE film set mapping",
        altDe: "Videoprojektion für Mercedes Benz CASE Werbedreh",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/mercedes-benz-case/mercedes-benz-case-lichtgestalten-2.jpg",
        altEn: "Rear projection film set in Stuttgart",
        altDe: "Rückprojektion für ein Film-Set in Stuttgart",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/mercedes-benz-case/mercedes-benz-case-lichtgestalten-5.jpg",
        altEn: "Rear projection film set for Mercedes Benz",
        altDe: "Rückprojektion für ein Film-Set von Mercedes Benz",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/mercedes-benz-case/mercedes-benz-case-lichtgestalten-4.jpg",
        altEn: "Projection mapping film set in Stuttgart",
        altDe: "Projection Mapping für Filmdreh in Stuttgart",
      },
    ],
    descriptionEn:
      "A boy dreams about the future of mobility. To help him visualise this dream, we were invited by '5ter Stock' to set up 3 projectors and augment his room. Premiered at CES Las Vegas 2019.",
    descriptionDe:
      "Mit einer Rückprojektion setzten wir für '5ter Stock' ein virtuelles Filmset um. So konnten die Wände eines Kinderzimmers zur Leinwand fantasievoller Traumsequenzen werden. Produziert für die CES Las Vegas 2019.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["02.02.2019"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: [
          "5ter Stock #https://www.5terstock.de/",
          "Mercedes-Benz",
        ],
      },
      {
        slugCreditsEn: "Animation",
        slugCreditsDe: "Animation",
        values: [
          "Bewegtbildgrafik #https://bewegtbildgrafik.de/",
        ],
      },
      {
        slugCreditsEn: "Projection Mapping",
        slugCreditsDe: "Projektion, Mapping",
        values: [
          "Lichtgestalten",
        ],
      },
    ],
    tags: ["mapping"],
  },
  //project start
  {
    shortTitle: "test",
    title: "OGLF step sequencer | ABK",
    slug: "oglf-step-sequencer",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/oglf-step-sequencer/OGLF_30.jpg",
    imageTitle: "OGLF step sequencer cover image",
    galleryContent:[
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/oglf-step-sequencer/OGLF_30.jpg",
        altEn: "Interactive step sequencer with realtime projection mapping at ABK, Stuttgart",
        altDe: "Interaktiver Step Sequencer mit Echtzeit-Videoprojektion an der ABK, Stuttgart",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/oglf-step-sequencer/OGLF_27.jpg",
        altEn: "Projection mapping on gauze cube",
        altDe: "Projektion auf einen Würfel",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/oglf-step-sequencer/OGLF_24.jpg",
        altEn: "Interactive step sequencer at ABK, Stuttgart",
        altDe: "Interaktiver Step Sequencer an der ABK, Stuttgart",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/oglf-step-sequencer/OGLF_25.jpg",
        altEn: "Projcetion Mapping at ABK, Stuttgart",
        altDe: "Videoprojektion an der ABK, Stuttgart",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/oglf-step-sequencer/OGLF_32.jpg",
        altEn: "Full white projection on cube",
        altDe: "Weiße Projektion auf Würfel",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/oglf-step-sequencer/OGLF_31.jpg",
        altEn: "OGLF cube projection mapping",
        altDe: "OGLF Würfel mit Videoprojektion",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/oglf-step-sequencer/OGLF_28.jpg",
        altEn: "Cube projection mapping with interactive animations",
        altDe: "Projektion auf Würfel mit interaktiven Animationen",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/oglf-step-sequencer/OGLF_29.jpg",
        altEn: "Gauze projection mapping with grid animations",
        altDe: "Videoprojektion mit Netzstruktur",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/oglf-step-sequencer/OGLF_26.jpg",
        altEn: "Interactive step sequencer with mapped animations",
        altDe: "Interaktiver Step Sequencer mit projizierten Animationen",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/oglf-step-sequencer/OGLF_35.jpg",
        altEn: "Projection mapping on gauze cube",
        altDe: "Videoprojektion auf Würfel mit interaktiven Animationen",
      },
    ],
    descriptionEn:
      "Together with graphic designer Christian Nicolaus we extended our installation XXO with visual elements. Following the core principles of a classic step-sequencer, the installation allowed 8 steps with 8 audiovisual-layers, using Max/MSP, Ableton and Resolume to achieve a flexible setup. The triggered graphics were combined with an atmospheric animation on the two semi-transparent projection screens.",
    descriptionDe:
      "Zusammen mit dem Kommunikationsdesigner Christian Nicolaus erweiterten wir unsere Installation 'XXO' mit visuellen Elementen. Angelehnt an einen klassischen Step Sequencer, konnten im OGLF Step Sequencer mit 8 Steps und 8 audiovisellen Ebenen interaktiv Musik und Animationen ausgelöst werden. Verwendet wurden dafür Max/MSP, Ableton und Resolume sowie eine Würfelkonstruktion mit halbtransparenten Leinwänden.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["03.07.2018"],
      },
      {
        slugCreditsEn: "Graphic Concept, Motion Design",
        slugCreditsDe: "Grafikkonzept, Animation",
        values: [
          "Bareis-Nicolaus #https://www.bareis-nicolaus.com",
        ],
      },
      {
        slugCreditsEn: "Interactive Concept, Programming & Installation",
        slugCreditsDe: "Interaktives Konzept, Programmierung & Installation",
        values: [
          "Lichtgestalten",
        ],
      },
    ],
    tags: ["interactive"],
  },
  //project start
  {
    shortTitle: "test",
    title: "lichtGestalten | Stadtpalais Stuttgart",
    slug: "lichtgestalten-stadtpalais-stuttgart",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-2.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-2.jpg",
        altEn: "Stadtpalais Stuttgart opening with LED light sculptures",
        altDe: "LED-Leuchtskulpturen bei der Eröffnung des Stadtpalais Stuttgart",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-1.jpg",
        altEn: "LED light sculpture sitting at the entrance of Stadtpalais Stuttgart",
        altDe: "Eine Leuchtskulptur sitzt am Eingang des Stadtpalais Stuttgart",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-5.jpg",
        altEn: "LED light sculpture breakdancing in front of Stadtpalais Stuttgart",
        altDe: "Eine Leuchtskulptur macht Breakdance vor dem Stadtpalais Stuttgart",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-6.jpg",
        altEn: "View of the back of the Stadtpalais Stuttgart with LED light sculptures",
        altDe: "Rückansicht des Stadtpalais Stuttgart mit LED-Leuchtskulpturen",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-7.jpg",
        altEn: "Light sculptures public installation build for the opening of the Stadtpalais Stuttgart",
        altDe: "Kunstinstallation mit leuchtenden Figuren zur Eröffnung des Stadtpalais Stuttgart",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-8.jpg",
        altEn: "LED light sculpture meditating at the Stadtpalais Stuttgart",
        altDe: "Eine Leuchtskulptur meditiert vor dem Stadtpalais Stuttgart",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-9.jpg",
        altEn: "Light sculptures by daylight in front of the Stadtpalais Stuttgart",
        altDe: "Leuchtskulpturen bei Tag vor dem Stadtpalais Stuttgart",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-10.jpg",
        altEn: "LED light sculptures at the entrance of the Stadtpalais Stuttgart",
        altDe: "Leuchtskulpturen am Eingang des Stadtpalais Stuttgart",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-11.jpg",
        altEn: "Back entrance of the Stadtpalais Stuttgart",
        altDe: "Hintereingang des Stadtpalais Stuttgart mit Lichtinstallation",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-13.jpg",
        altEn: "LED light sculpture at the Stadtpalais Stuttgart",
        altDe: "LED-Lichtinstallation am Stadtpalais Stuttgart",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-14.jpg",
        altEn: "Public light art installation with LED light sculptures at night in Stuttgart",
        altDe: "Leuchtskulptur bei Nacht an der Fassade des Stadtpalais Stuttgart",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-15.jpg",
        altEn: "Stadtpalais Stuttgart at night with lichtgestalten",
        altDe: "Stadtpalais Stuttgart bei Nacht mit den lichtgestalten",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-16.jpg",
        altEn: "Stadtpalais Stuttgart opening installation by lichtgestalten",
        altDe: "Lichtinstallation zur Eröffnung des Stadtpalais Stuttgart von lichtgestalten",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-17.jpg",
        altEn: "Stadtpalais Stuttgart LED light figure installation by lichtgestalten",
        altDe: "Lichtkunst am Stadtpalais Stuttgart mit LED-Lichtskulpturen",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-18.jpg",
        altEn: "LED light figure couple",
        altDe: "Lichtskulptur-Pärchen",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-3.jpg",
        altEn: "LED light sculpture climbing at Stadtpalais Stuttgart",
        altDe: "Eine Lichtskulptur klettert auf das Stadtpalais Stuttgart",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lichtgestalten-stadtpalais-stuttgart/lichtgestalten-stadtpalais-stuttgart-4.jpg",
        altEn: "Stadtpalais Stuttgart LED light figure",
        altDe: "Lichtskulptur am Stadtpalais Stuttgart",
      }
    ],
    descriptionEn:
      "‚Lichtgestalten‘ were commissioned to create an installation for the opening festival of the Stadtpalais Stuttgart, a museum dedicated to the city of Stuttgart and its history. 60 illuminated figures were installed on the facade to show a playful way of the city’s people reconquering this prestigious building. The ‚lichtGestalten‘ figures depict urban life in abstract ways, mimicking social interactions and the socially rejected side by side.",
    descriptionDe:
      "Für das Eröffnungsfestival des Stadtpalais Stuttgart bauten wir über 60 Lichtgestalten, die für 4 Wochen an der Fassade des Stadtpalais als Symbol für die Bürger Stuttgarts das Stadtmuseum erkundeten und zurückeroberten. Die wetterfesten, mit LEDs beleuchteten Figuren wurden in verschiedenen Posen angefertigt, um auf eine spielerische Art und Weise das Zusammenleben in einer Stadt wieder zu spiegeln.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["13.04. - 30.04.2018"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: [
          "Stadtpalais Stuttgart #https://www.stadtpalais-stuttgart.de/",
        ],
      },
      {
        slugCreditsEn: "Idea, Production & Installation",
        slugCreditsDe: "Idee, Produktion & Installation",
        values: [
          "Lichtgestalten",
        ],
      },
      {
        slugCreditsEn: "Technical Consulting",
        slugCreditsDe: "Technische Beratung",
        values: [
          "507nanometer",
        ],
      },
      {
        slugCreditsEn: "Photos",
        slugCreditsDe: "Fotos",
        values: ["Jan Potente #https://www.janpotente.de/"],
      },
    ],
    tags: ["installation"],
  },
  //project start
  {
    shortTitle: "test",
    title: "FC Bayern – Mapping | Allianz Arena",
    slug: "fcbayern-mapping-allianz-arena",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/fcbayern-mapping-allianz-arena/fcb-mapping-allianz-arena-2016-3.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/fcbayern-mapping-allianz-arena/fcb-mapping-allianz-arena-2016-3.jpg",
        altEn: "Allianz Arena projection mapping for FC Bayern München",
        altDe: "Videoprojektion in der Allianz Arena für den FC Bayern München",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/fcbayern-mapping-allianz-arena/fcb-mapping-allianz-arena-2016-1.jpg",
        altEn: "FC Bayern München logo projected on the pitch of Allianz Arena",
        altDe: "Logo des FC Bayern München als Projektion auf dem Spielfeld der Allianz Arena",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/fcbayern-mapping-allianz-arena/fcb-mapping-allianz-arena-2016-2.jpg",
        altEn: "DFB trophy and Meisterschale projection mapping at Allianz Arena München",
        altDe: "Projektion von DFB-Pokal und Meisterschale in der Allianz Arena München",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/fcbayern-mapping-allianz-arena/fcb-mapping-allianz-arena-2016-4.jpg",
        altEn: "Projection mapping at Allianz Arena for FC Bayern München",
        altDe: "Projection-Mapping in der Allianz Arena für den FC Bayern München",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/fcbayern-mapping-allianz-arena/fcb-mapping-allianz-arena-2016-5.jpg",
        altEn: "Video mapping at Allianz Arena for FC Bayern München",
        altDe: "Video-Mapping in der Allianz Arena für den FC Bayern München",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/fcbayern-mapping-allianz-arena/fcb-mapping-allianz-arena-2016-6.jpg",
        altEn: "Projection mapping christmas show at Allianz Arena for FC Bayern München",
        altDe: "Videoprojektion zu Weihnachten in der Allianz Arena für den FC Bayern München",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/fcbayern-mapping-allianz-arena/fcb-mapping-allianz-arena-2016-7.jpg",
        altEn: "FC Bayern München logo projection mapping",
        altDe: "FC Bayern München Logo als Videoprojektion",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/fcbayern-mapping-allianz-arena/fcb-mapping-allianz-arena-2016-8.jpg",
        altEn: "FC Bayern München Danke christmas video mapping show at Allianz Arena",
        altDe: "Der FC Bayern München sagt mit Video-Mapping 'Danke' zu Weihnachten in der Allianz Arena",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/fcbayern-mapping-allianz-arena/fcb-mapping-allianz-arena-2016-9.jpg",
        altEn: "FC Bayern München logo video mapping",
        altDe: "FC Bayern München Logo Videomapping",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/fcbayern-mapping-allianz-arena/fcb-mapping-allianz-arena-2016-10.jpg",
        altEn: "FC Bayern München logo projected on pitch of Allianz Arena",
        altDe: "FC Bayern München Logo auf das Spielfeld der Allianz Arena projiziert",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/fcbayern-mapping-allianz-arena/fcb-mapping-allianz-arena-2016-11.jpg",
        altEn: "FC Bayern München video mapping at Allianz Arena",
        altDe: "FC Bayern München Videoprojektion in der Allianz Arena",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/fcbayern-mapping-allianz-arena/fcb-mapping-allianz-arena-2016-12.jpg",
        altEn: "FC Bayern München video mapping projector rig",
        altDe: "FC Bayern München Projektion Making Of",
      }
    ],
    descriptionEn: 
      "After the last game of the year 2016, FC Bayern München had something special in mind to say ‚Danke‘ to their fans and supporters. A diverse projection mapping with 3D illusions covering the pitch in a retrospect of the last season and won trophies while celebrating the current team. Slowing down for a performance of the Tölzer Knabenchor in a christmas landscape after a short glimpse into Bavarian culture. And finally a grand ‚Danke‘ from the club and the team to the fan culture and their supporters.",
    descriptionDe:
      "Nach dem letzten Spieltag 2016, kurz vor Weihnachten, bedankte sich der FC Bayern München mit einem Videomapping auf der gesamten Fläche des Spielfelds der Allianz Arena bei seinen Fans für ihre Unterstützung. Mit Projektionen von Spielszenen der vergangenen Saison, der gewonnen Pokale, 3D-Illusionen, einem Auftritt des Tölzer Knabenchors bis zum großen Finale mit der gesamten Mannschaft in Mitten eines projizierten, überdimensionalen `Danke` wurden hier die vielseitigen Möglichkeiten eines Mappings unter komplexen Rahmenbedingungen aufgezeigt.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["21.12.2016"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: [
          "FC Bayern München AG (Executive Board Member: Andreas Jung | Director Media, Digital and Communication: Stefan Mennerich | Head of Events: Doris Kintrup",
        ],
      },
      {
        slugCreditsEn: "Creative Director",
        slugCreditsDe: "Creative Director",
        values: ["gewi - Thomas Gemeinwieser"],
      },
      {
        slugCreditsEn: "Art Director",
        slugCreditsDe: "Art Director",
        values: ["Lichtgestalten - Dominik Schatz, Philipp Kaiser"],
      },
      {
        slugCreditsEn: "Technical Planning / Technical Provider / Hardware",
        slugCreditsDe: "Technical Planning / Technical Provider / Hardware",
        values: ["Wilhelm & Whilhalm Event Technik - Katharina Maercks #https://www.wwet-group.de/"],
      },
      {
        slugCreditsEn: "Executive Director",
        slugCreditsDe: "Executive Director",
        values: ["MUSIC COMPANY Media Productions OHG - Philipp Diehl-Thiele"],
      },
      {
        slugCreditsEn: "Video Mapping / Animations",
        slugCreditsDe: "Video Mapping / Animations",
        values: ["loop light GmbH - Matt Finke, Matthias Etz #https://www.looplight.de/"],
      },
      {
        slugCreditsEn: "Stream / Documentation",
        slugCreditsDe: "Stream / Documentation",
        values: ["MM FILM & VIDEO Manfred Müller GmbH - Gerhard Friedrich"],
      },
      {
        slugCreditsEn: "Composer",
        slugCreditsDe: "Composer",
        values: ["audio video disco – sound solutions - Daniel Requardt #https://audio-video-disco.com/"],
      },
      {
        slugCreditsEn: "Editor",
        slugCreditsDe: "Editor",
        values: ["Monika Stoeger, Helmar Jungmann"],
      },
      {
        slugCreditsEn: "Set Designer",
        slugCreditsDe: "Set Designer",
        values: ["KRAUSS messe & event – Felix Krauss, Katrin Krauss, Michael Holzer"],
      },
      {
        slugCreditsEn: "LED Boards",
        slugCreditsDe: "LED Boards",
        values: ["AIM Sport AG #https://aimsport.com"],
      },
      {
        slugCreditsEn: "Thanks To",
        slugCreditsDe: "Danke",
        values: [
          "Allianz Arena München Gmbh #https://allianz-arena.com/de",
          "Stephan Lehmann",
          "EVISCO AG #https://www.evisco.com/",
          "FC BAYERN Jugendspieler",
          "Tölzer Knabenchor",
          "DO & CO München GmbH #https://www.doco.com/",
          "Joseph Vilsmaier"
        ],
      },
    ],
    tags: ["artDirection", "mapping"],
  },
  //project start
  {
    shortTitle: "test",
    title: "MS Dockville 2016 | Hamburg",
    slug: "ms-dockville-2016-hamburg",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Hands1.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Hands1.jpg",
      },
      {
        type: "video",
        url: "https://vimeo.com/472653350",
        aspect: "1.77777778",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Geburtstag2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Christo2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Christo5.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Bunt1.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Bunt2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Fernrohr2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Fische2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Font1.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Klekse2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Konfetti1.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Linien1.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Raster2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Silo4.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2016/lichtgestalten-msdockville-16-Trommeln1.jpg",
      },
    ],
    descriptionEn: 
      "We made our third trip to the MS Dockville Festival, but that doesn’t mean we’re getting tired. For the 10th anniversary of the festival we had a much bigger output than before, creating more than 10 artworks for the Rethespeicher, a 12 minute animation loop for the silo and some atmospheric tree projections on the festivals side itself.",
    descriptionDe:
      "2016 war unser dritter Ausflug nach Hamburg zum MS Dockville Festival - das zum zehnten Mal stattfand und damit ein Jubiläum feierte. Dafür projizierten wir einen 12minütigen Videoloop auf das Silo, über 10 Motive auf den Rethespeicher und setzten einige atmosphärische Projektionen in den Bäumen des Festivalgeländes um.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["18. – 21.08.2016"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: [
          "Kopf & Steine GmbH #https://www.kopfundsteine.de/",
        ],
      },
      {
        slugCreditsEn: "Production",
        slugCreditsDe: "Produktion",
        values: ["Lichtgestalten"],
      },
      {
        slugCreditsEn: "Desgin",
        slugCreditsDe: "Gestaltung",
        values: [
          "Fabian Friedrich #http://fabianfriedrich.com/",
          "Christian Nicolaus #http://christiannicolaus.de/",
          "Bewegtbildgrafik #http://bewegtbildgrafik.de/",
          "Lichtgestalten",
        ],
      },
      {
        slugCreditsEn: "Animation",
        slugCreditsDe: "Animation",
        values: [
          "Fabian Friedrich #http://fabianfriedrich.com/",
          "Lichtgestalten",
        ],
      },
      {
        slugCreditsEn: "Documentation",
        slugCreditsDe: "Animation",
        values: [
          "Laila Sieber",
          "Lichtgestalten",
        ],
      },
    ],
    tags: ["artDirection", "animation", "mapping"],
  },
  //project start
  {
    shortTitle: "test",
    title: "MLIVE | Berlin",
    slug: "mlive-berlin",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/mlive-berlin/mlive-berlin-2016-lichtgestalten-honne-live2.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/mlive-berlin/mlive-berlin-2016-lichtgestalten-honne-live2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/mlive-berlin/mlive-berlin-2016-lichtgestalten-fassadenprojektion2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/mlive-berlin/mlive-berlin-2016-lichtgestalten-honne-live.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/mlive-berlin/mlive-berlin-2016-lichtgestalten-projection.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/mlive-berlin/mlive-berlin-2016-lichtgestalten-projection2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/mlive-berlin/mlive-berlin-2016-lichtgestalten-setup.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/mlive-berlin/mlive-berlin-2016-lichtgestalten-stage1.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/mlive-berlin/mlive-berlin-2016-lichtgestalten-tom-misch-3.jpg",
      },
    ],
    descriptionEn: 
      "To kick of its worldwide MLIVE event series, Majestic Casual invited several acts like HONNE, Snakehips or Shir Khan to the Malzfabrik in Berlin. We were responsible for the conception, realisation and live-control of the stage- and light-design. To cover the wide range of musical styles with DJs and bands, we decided to combine projections and lighting which disappear when not in action with black projection surfaces. Furthermore we went for strong backlighting to emphasise the introvert and mystical style of the Majestic Casual brand.",
    descriptionDe:
      "MLIVE, eine weltweite Eventreihe von Majestic Casual, feierte seine Premiere mit einer Veranstaltung in der Malzfabrik Berlin. Mit dabei waren u.a. HONNE, Snakehips, Shir Khan und Tom Misch. Wir entwarfen und setzten die Bühnebeleuchtung um, die sowohl DJs als auch Bands in Szene setzen sollte. Dafür kombinierten wir Projektionen und Leuchten zu einem Hintergrund, der bei Bedarf in der Dunkelheit verschwinden konnte, um den eher introvertierten Stil von Majestic Casual gerecht zu werden.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["05.02.2016"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: ["Majestic Casual #https://www.youtube.com/user/majesticcasual?gl=DE&hl=de"],
      },
      {
        slugCreditsEn: "Event",
        slugCreditsDe: "Event",
        values: ["Do The Do #https://www.gottadothedo.com/"],
      },
      {
        slugCreditsEn: "Production, Stage Design, Animation & Operating",
        slugCreditsDe: "Produktion, Bühne & Animation",
        values: ["Lichtgestalten"],
      },
    ],
    tags: ["artDirection", "animation"],
  },
  //project start
  {
    shortTitle: "test",
    title: "3D Audio Konzert | Eau Rouge",
    slug: "eau-rouge-3d-audio-concert",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/eau-rouge-3d-audio-concert/lichtgestalten-eau-rouge-3d-audio-concert-6.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/eau-rouge-3d-audio-concert/lichtgestalten-eau-rouge-3d-audio-concert-6.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/eau-rouge-3d-audio-concert/lichtgestalten-eau-rouge-3d-audio-concert-9.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/eau-rouge-3d-audio-concert/lichtgestalten-eau-rouge-3d-audio-concert-5.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/eau-rouge-3d-audio-concert/lichtgestalten-eau-rouge-3d-audio-concert-8.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/eau-rouge-3d-audio-concert/lichtgestalten-eau-rouge-3d-audio-concert-3.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/eau-rouge-3d-audio-concert/lichtgestalten-eau-rouge-3d-audio-concert-2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/eau-rouge-3d-audio-concert/lichtgestalten-eau-rouge-3d-audio-concert-10.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/eau-rouge-3d-audio-concert/lichtgestalten-eau-rouge-3d-audio-concert-1.jpg",
      },
    ],
    descriptionEn: 
      "Benedikt Maile and Daniel Schiffner teamed up with the Stuttgart based band Eau Rouge to create and experiment with a rather uncommon live setup at the Hochschule der Medien Stuttgart. 40 speakers and 4 subwoofers were rigged in 3 different heights to enable wave field synthesis, which allows to place audio signals in a virtual spatial environment and experience Eau Rouge 3D. Simply said, you are able to exactly locate where the sound is coming from and single instruments can be placed behind you or rotate around your head for creative and psychedelic effects. To support this omnidirectional experience visually, we first worked out a way to distribute light evenly in the room or place beams in specific locations without an excessive setup. A mirrored hemisphere, heavy fog and 15.000 ANSI-Lumen helped us to achieve this goal. The two audio engineers intended to stay close to classic setups and use the 3D sound capabilities for subtle effects, so we supported the musical climaxes with strobes and backlighting on stage.",
    descriptionDe:
      "Zusammen mit der Stuttgarter Band 'Eau Rouge' realisierten Benedikt Maille und Daniel Schiffner ein experimentelles 3D-Audio-Konzert an der Hochschule der Medien in Stuttgart. 40 Lautsprecher und 4 Subwoofer wurden in verschiedenen Höhen montiert, um ein räumliches Klangerlebnis zu schaffen, bei dem ein Sound scheinbar beliebig im Raum platziert werden kann. Um diese Räumlichkeit auch visuell aufgreifen zu können, projizierten wir mit einem Projektor auf eine spiegelnde Halbkugel, wodurch wir mit einem relativ subtilem Setup räumliche, audioreaktive Animationen umsetzen konnten.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["18. - 19.02.2016"],
      },
      {
        slugCreditsEn: "Production",
        slugCreditsDe: "Produktion",
        values: ["Benedikt Maille, Daniel Schiffner"],
      },
      {
        slugCreditsEn: "Music",
        slugCreditsDe: "Musik",
        values: ["Eau Rouge"],
      },
      {
        slugCreditsEn: "Animation & Light Design",
        slugCreditsDe: "Animation & Lichtgestaltung",
        values: ["Lichtgestalten"],
      },
      {
        slugCreditsEn: "Photos",
        slugCreditsDe: "Fotos",
        values: ["Jan Potente #https://www.janpotente.de/"],
      },
    ],
    tags: ["artDirection", "animation"],
  },
  //project start
  {
    shortTitle: "test",
    title: "MS Dockville 2015 | Hamburg",
    slug: "ms-dockville-2015",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-3d_font.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-3d_font.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-balloon_font.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-dockville-pipes.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-grid.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-anchor-fog.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-leuchtturm-publikum.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-line-font-2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-lineup.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-silo-bullauge.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-silo-bullauge2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-silo-fisch1.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-silo-fisch3.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-silo-krake2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-silo-krake3.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-silo-leuchtturm1.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-silo-leuchtturm2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-silo-pipe-font.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-silo-seemann.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2015/ms-dockville-2015-lichtgestalten-the_better_the_beer.jpg",
      },
    ],
    descriptionEn: 
      "Our second time projecting at the MS Dockville Festival proved again that this festival is one of our highlights. We had the pleasure to map the 170m x 75m surface of the Rethespeicher, the projection flagship of the MS Dockville 2015, and the 50m tall silo next to it. The silo was our proving ground for a new workflow, as we distorted the content onto the convex shape to fit perfectly to the perspective of the festival audience on the other side of the 200m wide channel, creating the illusion that the silos front is invisible.",
    descriptionDe:
      "Unser zweiter Ausflug zum MS Dockville Festival in Hamburg ermöglichte es uns erneut, den 170x75m großen Rethspeicher mit Motiven zu bespielen. Zudem konnten wir auf dem Silo einen neuen Workflow für die Umsetzung einer 'Trompe-l’œil'-Illusion ausprobieren, damit die zum Festivalgelände laufenden Besucher mit einer virtuell unsichtbaren Silo-Wand und scheinbar dreidimensionalen Motiven auf das Festival eingestimmt werden.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["20. - 23.08.2015"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: [
          "Kopf & Steine GmbH #https://www.kopfundsteine.de/",
        ],
      },
      {
        slugCreditsEn: "Production",
        slugCreditsDe: "Produktion",
        values: ["Lichtgestalten"],
      },
      {
        slugCreditsEn: "Design",
        slugCreditsDe: "Gestaltung",
        values: [
          "Fabian Friedrich #http://fabianfriedrich.com/",
          "Christian Nicolaus #http://christiannicolaus.de/",
          "Lichtgestalten",
        ],
      },
      {
        slugCreditsEn: "Animation",
        slugCreditsDe: "Animation",
        values: [
          "Fabian Friedrich #http://fabianfriedrich.com/",
          "Lichtgestalten",
        ],
      },
      {
        slugCreditsEn: "Documentation",
        slugCreditsDe: "Dokumentation",
        values: [
          "David Dollmann #http://daviddollmann.com/",
          "Lukas Nicolaus #http://lukasnicolaus.de/",
        ],
      },
    ],
    tags: ["artDirection", "animation", "mapping"],
  },
  //project start
  {
    shortTitle: "test",
    title: "Die Vier Letzten Dinge | Stuttgart",
    slug: "die-vier-letzten-dinge-stuttgart",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/die-vier-letzten-dinge-stuttgart/dievierletztendinge-lichtgestalten-1.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "video",
        url: "https://vimeo.com/132700768",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/die-vier-letzten-dinge-stuttgart/dievierletztendinge-lichtgestalten-1.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/die-vier-letzten-dinge-stuttgart/dievierletztendinge-lichtgestalten-2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/die-vier-letzten-dinge-stuttgart/dievierletztendinge-lichtgestalten-3.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/die-vier-letzten-dinge-stuttgart/dievierletztendinge-lichtgestalten-4.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/die-vier-letzten-dinge-stuttgart/dievierletztendinge-lichtgestalten-5.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/die-vier-letzten-dinge-stuttgart/dievierletztendinge-lichtgestalten-6.jpg",
      },
    ],
    descriptionEn: 
      "Silinee Damsa-Ard and Philip Roscher developed the piece 'Die Vier Letzten Dinge' as part of the Terrorisms International Theatre Festival in Stuttgart. Dealing with a protagonist who loses himself in a never ending clash of religious and social values, the piece tries to find answers for well known question: is there an objective truth? And why do different philosophies and mindsets claim superiority over contradicting or deviant opinions? Miodrag Nerandzic designed the modular stage, which evolves from a 2,20 m sized cube to a cathedral like wall. Throughout the piece, the protagonist locks himself into his own world. Lichtgestalten used this black canvas to work with the concept of perspective: if there’s only one perspective, but we view it from different angles, is it still the same perspective? Are we overchallenged if there are too many perspectives? How much information do we need to perceive something in its intended perspective?",
    descriptionDe:
      "Im Rahmen des 'Terrorism-Theater-Festival' am Staatstheater Stuttgart entwickelten Silinee Damsa-Ard und Philip Roscher das Stück 'Die Vier Letzten Dinge'. Miodrag Nerandzic konzipierte das Bühnenbild, das eine Transformation eines 2,20m großen Würfen zu den Wänden einer Kathedrale erlaubte. Lichtgestalten nutzten diese Leinwand, um das Spiel mit Perspektiven und dem Verlust ebendieser durch Videoprojektionen aufzugreifen.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["25. - 27.06.2015"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: ["Staatstheater Stuttgart #https://www.staatstheater-stuttgart.de/"],
      },
      {
        slugCreditsEn: "Production, Concept & Animation",
        slugCreditsDe: "Produktion, Konzept & Animation",
        values: ["Lichtgestalten"],
      },
      {
        slugCreditsEn: "Documentation",
        slugCreditsDe: "Dokumentation",
        values: [ 
          "Video, photos 1 - 3 | Jan Potente #https://www.janpotente.de/",
          "Photos 3 - 5 | Anastasia Hermann #https://anastasiahermann.de/"
        ]
      },
    ],
    tags: ["artDirection", "animation", "mapping"],
  },
  //project start
  {
    shortTitle: "test",
    title: "THIS IS HOW WE DO IT | ABK",
    slug: "this-is-how-we-do-it-stuttgart",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/this-is-how-we-do-it-stuttgart/this-is-how-we-do-it-lichtgestalten-2.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "video",
        url: "https://vimeo.com/117272620",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/this-is-how-we-do-it-stuttgart/this-is-how-we-do-it-lichtgestalten-2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/this-is-how-we-do-it-stuttgart/this-is-how-we-do-it-lichtgestalten-3.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/this-is-how-we-do-it-stuttgart/this-is-how-we-do-it-lichtgestalten-4.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/this-is-how-we-do-it-stuttgart/this-is-how-we-do-it-lichtgestalten-5.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/this-is-how-we-do-it-stuttgart/this-is-how-we-do-it-lichtgestalten-6.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/this-is-how-we-do-it-stuttgart/this-is-how-we-do-it-lichtgestalten-8.jpg",
      },
    ],
    descriptionEn: 
      "To celebrate the 25th anniversary of the architecture department at the State Academy of Art and Design in Stuttgart, the international two-day conference „This is how we do it“ took place. The aim of the project was to give a lecture on the theme of architectural education in general and to discuss the contents. The focus was on regarding the State Academy to other kinds of universities, and on the question of free development.The two graphic designer Christian Nicolaus and Ute Mueller-Schloesser developed the title „This is how we do it“ as well as the relating concept and visualization of the event. The concept and animations for the projection mapping were developed by the Stuttgart based visual artists Lichtgestalten. The basic approach for the graphic design plays with the concept of ‚unfolding‘, particulary regarding the development of ideas and workflows in the context of different philosophies of architectural education. Eventually Christian Nicolaus and Ute Mueller-Schloesser found a way to combine the opposing phrases „This Is How We Do It“ and „This Is How They Do It“ on the cover of the invitation card with a special folding. The same folding structure was also used for the poster, so that the visible content depends on the perspective of the people passing by. The projection mapping itself was developed to further extend these ideas. Using light and shadow, a virtual light source floating in ‚front‘ of the installation revealed the contents of the poster. The installation consisted of one printed poster in the center and two blanc canvases on the left and right. As the projection was accompanying the talks, we decided to go for a subtle approach. Playing with light/shadow and printed/projected media allowed us to create a canvas to play with illusions and contrast, highlighting the structure without distracting from the content.",
    descriptionDe:
      "Zum 25. Jubiläum des Fachbereichs Architektur der Staatlichen Akademie der Bildenden Künste in Stuttgart entwarfen Christian Nicolaus und Ute Mueller-Schloesser unter dem Motto 'This is how we do it' ein Plakat, dessen Inhalt durch Faltung verändert werden konnte. Mit einem Videomapping bespielten wir dieses Plakat mit virtuellen Schatten und Lichtern sowie Negativbildern.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["05. - 06.12.2014"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: ["Christian Nicolaus #http://christiannicolaus.de/"],
      },
      {
        slugCreditsEn: "Production & Animation",
        slugCreditsDe: "Produktion & Animation",
        values: ["Lichtgestalten"],
      },
      {
        slugCreditsEn: "Concept",
        slugCreditsDe: "Konzept",
        values: [
          "Christian Nicolaus #http://christiannicolaus.de/",
          "Lichtgestalten",
        ],
      },
      {
        slugCreditsEn: "Poster Design",
        slugCreditsDe: "Gestaltung Poster",
        values: [
          "Christian Nicolaus #http://christiannicolaus.de/",
          "Uter Müller-Schlösser",
        ],
      },
    ],
    tags: ["artDirection", "animation", "mapping"],
  },
  //project start
  {
    shortTitle: "test",
    title: "MS Dockville 2014 | Hamburg",
    slug: "ms-dockville-2014-hamburg",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/ms-dockville-2014-hamburg/ms-dockville-2014-lichtgestalten-1.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "video",
        url: "https://vimeo.com/108559398",
        aspect: "1.7777778",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2014-hamburg/ms-dockville-2014-lichtgestalten-1.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2014-hamburg/ms-dockville-2014-lichtgestalten-2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2014-hamburg/ms-dockville-2014-lichtgestalten-3.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2014-hamburg/ms-dockville-2014-lichtgestalten-4.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2014-hamburg/ms-dockville-2014-lichtgestalten-5.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2014-hamburg/ms-dockville-2014-lichtgestalten-7.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2014-hamburg/ms-dockville-2014-lichtgestalten-8.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ms-dockville-2014-hamburg/ms-dockville-2014-lichtgestalten-9.jpg",
      },
    ],
    descriptionEn: 
      "The MS Dockville Festival in Hamburg invited us to do several installations over the weekend (15. – 17.08.2014). The large-scale projection on the “Rethespeicher” was without any doubt the eye-catcher of the five installations we did. The “Rethespeicher” has a size of around 170×75 meters, posing a perfect canvas for the artworks and projection mappings which were designed to fit to the architecture. The idea for the second largest projection was born on site, leaving only 2 days for the preparation and installation of two 10.000 Lumen projectors on top of a 30m high tower. The target was a 50m tall silo. The soft-edge projection was mapped to the convex shape to minimize perspective distortion. The animations, which could be seen perfectly from the crowd approaching the festival through the main entrance, included the line up of the MS Dockville 2014.",
    descriptionDe:
      "Für das MS Dockville Festival 2014 konzipierten und realisierten wir verschiedene audiovisuelle Installationen. Die Fassadenprojektion auf den 170 x 75 Meter großen Rethespeicher war dabei definitiv die auffälligste Installation. Die hierfür erstellten Motive wurden passgenau an die Architektur des Rethespeichers angepasst. Die Idee für die zweite Installation entstand erst vor Ort, wobei wir 2 Projektoren auf einem 30m hohen Turm installierten, um das benachbarte 50m hohe Silo mit Videoprojektionen per Soft-Edge-Mapping zu bespielen.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["15. - 17.08.2014"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: ["Kopf & Steine GmbH #https://www.kopfundsteine.de/"],
      },
      {
        slugCreditsEn: "Production",
        slugCreditsDe: "Produktion",
        values: ["Lichtgestalten"],
      },
      {
        slugCreditsEn: "Design",
        slugCreditsDe: "Gestaltung",
        values: [
          "Fabian Friedrich #http://fabianfriedrich.com/",
          "Christian Nicolaus #http://christiannicolaus.de/",
          "Lichtgestalten",
        ],
      },
      {
        slugCreditsEn: "Animation",
        slugCreditsDe: "Animation",
        values: [
          "Fabian Friedrich #http://fabianfriedrich.com/",
          "Lichtgestalten",
        ],
      },
      {
        slugCreditsEn: "Documentation",
        slugCreditsDe: "Dokumentation",
        values: [
          "David Dollmann #http://daviddollmann.com/",
        ],
      },
    ],
    tags: ["artDirection", "animation", "mapping"],
  },
  //project start
  {
    shortTitle: "test",
    title: "SPEKTRUM 2014 | Hamburg",
    slug: "spektrum-2014-hamburg",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/spektrum-2014-hamburg/spektrum-2014-lichtgestalten-1.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "video",
        url: "https://vimeo.com/110302078",
        aspect: "1.7777778",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/spektrum-2014-hamburg/spektrum-2014-lichtgestalten-1.jpg",
      },
    ],
    descriptionEn: 
      "On the 2nd of August the SPEKTRUM Festival in Hamburg took place. It’s motto „Momentaufnahme Beatkultur“ defines an aim to show what’s going on in all the different genres of beat driven music inside and around the umbrella term of „Hip Hop“. We got the offer to illuminate a wall of 2×3 40′ cargo containers which seperates two stages. To meet the cutting edge motto of the SPEKTRUM festival, we didn’t want to go for classic fullscale projections, but rather give the audience the possibility to scan the surface with an imaginery light for it’s contents. The subtle projection was driven by a tracked pendulum, controlling a 3D engine to generate realtime lights (driven by the pendulum), shadows and reflections of pre-animated objects in front of the container wall.",
    descriptionDe:
      "Am 02. August fand das SPEKTRUM Festival in Hamburg statt, das unter dem Motto 'Momentaufnahme Beatkultur' den verschiedenen Strömungen innerhalb der Beatkultur eine Plattform bietet. Dafür wurden lichtgestalten beauftragt, eine Schallschutzwand aus 2x3 40'HC Containern zu bespielen. Mit einer Pendelinstallation, die es den Besuchern des Festivals erlaubte, die Projektionsinhalte interaktiv zu steueren, konnte z.B. eine virtuelle Lichtquelle bewegt werden und das Line-Up des Festivals auf spielerische Art und Weise über eine 3D-Engine sichtbar gemacht werden.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["02.08.2014"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: ["Kopf & Steine GmbH #https://www.kopfundsteine.de/"],
      },
      {
        slugCreditsEn: "Concept, Production, Animation, Mapping",
        slugCreditsDe: "Konzept, Produktion, Animation & Mapping",
        values: ["Lichtgestalten"],
      },
      {
        slugCreditsEn: "Documentation",
        slugCreditsDe: "Dokumentation",
        values: ["Jan Wittekindt"],
      },
    ],
    tags: ["interactive", "animation", "mapping"],
  },
  //project start
  {
    shortTitle: "test",
    title: "Lange Nacht der Museen 2014 | Böblingen",
    slug: "lange-nacht-der-museen-2014-boeblingen",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/lange-nacht-der-museen-2014-boeblingen/lange-nacht-der-museen-boeblingen-lichtgestalten-2014-1.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lange-nacht-der-museen-2014-boeblingen/lange-nacht-der-museen-boeblingen-lichtgestalten-2014-1.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lange-nacht-der-museen-2014-boeblingen/lange-nacht-der-museen-boeblingen-lichtgestalten-2014-2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lange-nacht-der-museen-2014-boeblingen/lange-nacht-der-museen-boeblingen-lichtgestalten-2014-3.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lange-nacht-der-museen-2014-boeblingen/lange-nacht-der-museen-boeblingen-lichtgestalten-2014-5.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lange-nacht-der-museen-2014-boeblingen/lange-nacht-der-museen-boeblingen-lichtgestalten-2014-4.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lange-nacht-der-museen-2014-boeblingen/lange-nacht-der-museen-boeblingen-lichtgestalten-2014-6.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/lange-nacht-der-museen-2014-boeblingen/lange-nacht-der-museen-boeblingen-lichtgestalten-2014-7.jpg",
      },
    ],
    descriptionEn: 
      "As part of the „Lange Nacht der Museen“ we illuminated the „St. Dionysius“ church in Böblingen. Content-wise we went for a mixed approach, as we wanted to be able to cover the total period of the event (7 hours) with interesting content: some animations played with the architecture, proposing different settings and transforming the central place into other scenes like a lighthouse, the launch of a rocket or highrises. In between those „scripted“ animations we prepared loose elements based on abstract geometry and the structure of the building. Thus we could jam and improvise on this large canvas or tell short storys with the scripted animations.",
    descriptionDe:
      "Die Kirche 'St. Dionysius' in Böblingen war unsere Leinwand für die 'Lange Nacht der Museen 2014' in Böblingen. Mit einer Mischung aus vorgerenderten Videos und generativen, improvisierten Animationen konnten wir 7 Stunden mit abwechslungsreichen Projektionen auf der Fassade der Kirche gestalten. So wurde die Kirche u.a. in einen Leuchtturm, einen Raketenstart oder ein Hochhaus verwandelt.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["15.11.2014"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: ["Outer Rim Stuttgart #https://outerrimblog.wordpress.com/"],
      },
      {
        slugCreditsEn: "Concept, Animation & Mapping",
        slugCreditsDe: "Konzept, Animation & Mapping",
        values: ["Lichtgestalten"],
      },
    ],
    tags: ["animation", "mapping"],
  },
  //project start
  {
    shortTitle: "test",
    title: "Beyond Festival | ZKM Karlsruhe",
    slug: "3d-symposium-beyond-festival-zkm-karlsruhe",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/3d-symposium-beyond-festival-zkm-karlsruhe/zkm-beyond-festival-lichtgestalten-3.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/3d-symposium-beyond-festival-zkm-karlsruhe/zkm-beyond-festival-lichtgestalten-3.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/3d-symposium-beyond-festival-zkm-karlsruhe/zkm-beyond-festival-lichtgestalten-2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/3d-symposium-beyond-festival-zkm-karlsruhe/zkm-beyond-festival-lichtgestalten-1.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/3d-symposium-beyond-festival-zkm-karlsruhe/zkm-beyond-festival-lichtgestalten-4.jpg",
      },
    ],
    descriptionEn: 
      "The Beyond Symposium explores and discusses the use and influence of new technologies and experimental art forms. We were invited to set the atmosphere for the come together, there a relaxed room for conversations met the dancefloor of an aftershow party. Combining a translucent material with projections, we achieved a set of vivid clouds with the ability to explore a broad array from ambient illumination to intense thunderstorms.",
    descriptionDe:
      "Das Beyond Symposium am ZKM Karlsruhe beschäftigt sich mit neuen Technologien und experimentellen Kunstformen. Mit wolkenähnlichen Gebilden aus halbtransparenten Materalien konnten wir durch verschiedene Videoprojektionen sowohl die passende Atmosphäre für entspannte Gespräche sowie die anschließende After-Show-Party schaffen, so z.B. durch langsame organische Animationen als Grundbeleuchtung bis hin zu gewitterähnlichen Stroboskopeffekten.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["11.10.2014"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: ["ZKM Karlsruhe #https://zkm.de"],
      },
      {
        slugCreditsEn: "Concept, Production & Mapping",
        slugCreditsDe: "Konzept, Produktion & Mapping",
        values: ["Lichtgestalten"],
      },
    ],
    tags: ["mapping", "installation"],
  },
  //project start
  {
    shortTitle: "test",
    title: "Überblume | Marienplatzfest",
    slug: "ueberblume-marienplatzfest-stuttgart",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/ueberblume-marienplatzfest-stuttgart/ueberblume-marienplatztfest-2015-lichtgestalten-4.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ueberblume-marienplatzfest-stuttgart/ueberblume-marienplatztfest-2015-lichtgestalten-4.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ueberblume-marienplatzfest-stuttgart/ueberblume-marienplatzfest-2014-lichtgestalten-2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ueberblume-marienplatzfest-stuttgart/ueberblume-marienplatzfest-2014-lichtgestalten-1.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ueberblume-marienplatzfest-stuttgart/ueberblume-marienplatztfest-2015-lichtgestalten-6.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ueberblume-marienplatzfest-stuttgart/ueberblume-marienplatztfest-2015-lichtgestalten-1.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ueberblume-marienplatzfest-stuttgart/ueberblume-marienplatztfest-2015-lichtgestalten-3.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ueberblume-marienplatzfest-stuttgart/ueberblume-marienplatztfest-2015-lichtgestalten-7.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/ueberblume-marienplatzfest-stuttgart/ueberblume-marienplatztfest-2015-lichtgestalten-5.jpg",
      },
    ],
    descriptionEn: 
      "The installation 'Überblume' was a set of 20 artificial flowers, which served as shadow casters at daytime and as artificial suns at night. Their translucent blossom was sprayed with different colours, which revealed a variety of gradients depending on the perspective of the spectator. Because of their flexible straw they waved in the wind and softened the rigid atmosphere of the surrounding architecture. At night, 3 projectors illuminated the blossoms, highlighting the complex three dimensional structure of the mesh.",
    descriptionDe:
      "Die Installation 'Überblume' bestand aus 20 künstlichen Blumen, die bei Tag als Schattenspender und bei Nacht als Leuchtobjekte den Marienplatz in Stuttgart verzierten. Die aus halbtransparentem Material bestehenden Blüten wurden mit Farbverläufen angesprüht, wodurch sie je nach Blickwinkel unterschiedliche Farbeindrücke hinterließen. Durch ihren elastischen 'Halm' reagierten sie sanft auf Windstöße und verpassten dem urbanen, steinernen Marienplatz eine organische Komponente.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: [" 03. – 06.07.2014 & 02. – 05.07.2015"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: ["Marienplatzfest"],
      },
      {
        slugCreditsEn: "Concept, Production & Installation",
        slugCreditsDe: "Konzept, Produktion & Installation",
        values: ["Lichtgestalten"],
      },
    ],
    tags: ["installation"],
  },
  //project start
  {
    shortTitle: "test",
    title: "XXO | Step Sequencer",
    slug: "xxo-step-sequencer-stuttgart",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/xxo-step-sequencer-stuttgart/xxo-interactive-step-sequencer-lichtgestalten-1.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "video",
        url: "https://vimeo.com/101651264",
        aspect: "1.77777778",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/xxo-step-sequencer-stuttgart/xxo-interactive-step-sequencer-lichtgestalten-1.jpg",
      },
    ],
    descriptionEn: 
      "Interactive audio/visual step sequencer, programmed and installed by lichtgestalten. By placing paper objects (in this case our business cards) on the projected matrix, the spectator is able to programm rhythmic patterns. Those patterns can trigger any sound you want via MIDI. Set Up: projector / web cam / ableton live / max msp",
    descriptionDe:
      "'XXO' ist ein interaktiver, audiovisueller Step Sequencer, der von lichtgestalten konzipiert und programmiert wurde. Das Verschieben von Papierobjekten in einem projizierten Raster ermöglicht es, Rhythmen oder Melodien zu programmieren. Über MIDI werden anschließen Klänge ausgelöst. Durch die Größe des Bedienfelds des Step Sequencers erfordert 'XXO' eine Art Performance des Interagierenden.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["12.06.2015 & 05.2015"],
      },
      {
        slugCreditsEn: "Concept, Programming & Installation",
        slugCreditsDe: "Konzept, Programmierung & Installation",
        values: ["Lichtgestalten"],
      },
    ],
    tags: ["interactive", "installation"],
  },
  //project start
  {
    shortTitle: "test",
    title: "Eau Rouge – Golden Nights",
    slug: "eau-rouge-golden-nights-stuttgart",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/eau-rouge-golden-nights-stuttgart/GOLDEN-NIGHTS-02-LICHTGESTALTEN.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "video",
        url: "https://vimeo.com/107140667",
        aspect: "2",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/eau-rouge-golden-nights-stuttgart/GOLDEN-NIGHTS-02-LICHTGESTALTEN.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/eau-rouge-golden-nights-stuttgart/GOLDEN-NIGHTS-03-LICHTGESTALTEN.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/eau-rouge-golden-nights-stuttgart/GOLDEN-NIGHTS-04-LICHTGESTALTEN.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/eau-rouge-golden-nights-stuttgart/GOLDEN-NIGHTS-01-LICHTGESTALTEN.jpg",
      },
    ],
    descriptionEn: 
      "We were part of the production cast for the music video to „Golden Nights“ by Eau Rouge. The goal of our projections was to reveal the emotions of the lyrical self, in this case the singer Jonas. As the lyrics are about euphoric moments (represented by gold), we switched Jonas‘ black and cold „bloodflow“ into a golden stream. Later he had particles of endorphin flying all over his body. We animated and mapped the FullHD content onto Jonas‘ body and advised the production team with technical details.",
    descriptionDe:
      "Für das Musikvideo der Band 'Eau Rouge' setzten wir ein Videomapping auf einen Körper um. Die Projektionen arbeiteten dabei mit einer Abstraktion des Begriffs 'Euphorie', wobei sowohl schwarze und goldene Flüssigkeitsströme als auch Partikelexplosionen zum Einsatz kamen.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["01.12.2014"],
      },
      {
        slugCreditsEn: "Client",
        slugCreditsDe: "Kunde",
        values: ["Eau Rouge"],
      },
      {
        slugCreditsEn: "Production",
        slugCreditsDe: "Produktion",
        values: [
          "Till Beckert #https://www.tillbeckert.de/",
          "Daniel Schinow",
        ],
      },
      {
        slugCreditsEn: "Concept, Animation & Mapping",
        slugCreditsDe: "Konzept, Animation & Mapping",
        values: ["Lichtgestalten"],
      },
    ],
    tags: ["animation", "mapping"],
  },
  //project start
  {
    shortTitle: "test",
    title: "Square Swarm",
    slug: "square-swarm-rocker33-stuttgart",
    imageURL:
      "https://lichtgst.uber.space/photos/projects/square-swarm-rocker33-stuttgart/square-swarm-rocker-lichtgestalten-1.jpg",
    imageTitle: "testBild",
    galleryContent:[
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/square-swarm-rocker33-stuttgart/square-swarm-rocker-lichtgestalten-1.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/square-swarm-rocker33-stuttgart/square-swarm-rocker-lichtgestalten-2.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/square-swarm-rocker33-stuttgart/square-swarm-rocker-lichtgestalten-3.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/square-swarm-rocker33-stuttgart/square-swarm-rocker-lichtgestalten-4.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/square-swarm-rocker33-stuttgart/swarm-wilhelmspalais-stuttgart-lichtgestalten-1.jpg",
      },
      {
        type: "image",
        url: "https://lichtgst.uber.space/photos/projects/square-swarm-rocker33-stuttgart/swarm-wilhelmspalais-stuttgart-lichtgestalten-2.jpg",
      },
    ],
    descriptionEn: 
      "The square swarm was a live VJing – projection mapping onto more than 120 surfaces (Dimensions: DIN A6, A5, A4). It’s diffuse arrangement emits a very organic feel, which is supported by irregular visual patterns rather than linear patterns. Temporarily Installed at Rocker33, Stuttgart and Wilhelmspalais, Stuttgart.",
    descriptionDe:
      "'Square Swarm' war eine live VJing - Projection Mapping Installation mit mehr als 120 Papierflächen in den Größen DIN A6, A5 und A4. Durch die organische Anordnung der Papierflächen und das präzise Mapping der Videoprojektion ergaben sich komplexe visuelle Eindrücke. 'Square Swarm' wurde im Rocker33 und dem Wilhelmspalais in Stuttgart installiert.",
    info: [
      {
        slugCreditsEn: "Date",
        slugCreditsDe: "Datum",
        values: ["08.03.2013"],
      },
      {
        slugCreditsEn: "Concept, Animation & Live",
        slugCreditsDe: "Konzept, Animation & Live",
        values: ["Lichtgestalten"],
      },
    ],
    tags: ["mapping"],
  },
];
